'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var svg_path = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M12.0999 3V21.2M21.1999 12.0935H2.99994M19.8999 12.0935C19.8996 14.1627 19.0779 16.1471 17.6153 17.6108C16.1528 19.0746 14.1691 19.8979 12.0999 19.9C7.79303 19.9 4.29994 16.3978 4.29994 12.0935C4.30097 10.0256 5.12325 8.04277 6.58595 6.58104C8.04866 5.11931 10.032 4.29835 12.0999 4.2987C14.1677 4.2987 16.1509 5.11976 17.6135 6.58142C19.0761 8.04307 19.8985 10.0257 19.8999 12.0935Z\" stroke=\"#26201F\" stroke-width=\"1.4\" stroke-linecap=\"square\"/>\n</svg>";

exports["default"] = svg_path;
